import React, { useEffect, useMemo, useState } from "react";
import { useTable, useFilters, useSortBy } from "react-table";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import DialogClienteAcordoMaterial from "./components/DialogClienteAcordoMaterial";
import DialogClienteAcordoMaterialAlternativo from "./components/DialogClienteAcordoMaterialAlternativo";
import DialogClienteAcordoMaterialAlternativosLista from "./components/DialogClienteAcordoMaterialAlternativosLista";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import TableViewIcon from "@mui/icons-material/TableView";
import InfoIcon from "@mui/icons-material/Info";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

function TextFilter({ column: { filterValue, setFilter } }) {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder="filtrar..."
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    />
  );
}

function SimNaoFilter({ column: { filterValue, setFilter } }) {
  return (
    <select
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    >
      <option value="">Todos</option>
      <option value="1">Sim</option>
      <option value="0">Não</option>
    </select>
  );
}

function AtivoFilter({ column: { filterValue, setFilter } }) {
  return (
    <select
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    >
      <option value="">Todos</option>
      <option value="0">Ativos</option>
      <option value="1">Inativos</option>
    </select>
  );
}

const FILTERS_KEY = "tbl:clientesacordosmateriais:filters";
const KEEP_KEY = "tbl:clientesacordosmateriais:keep";

const clienteLabel = (c) => (c?.nome ? `${c.nome} (${c.ref})` : "");

const fabricanteLabel = (f) => (f?.nome ? `${f.nome} (${f.ref})` : "");

const materialLabel = (m) => (m?.nome ? `${m.nome} (${m.ref})` : "");

export default function ClientesAcordosMateriais() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [clientesCombo, setClientesCombo] = useState([]);
  const [fabricantesCombo, setFabricantesCombo] = useState([]);
  const [materiaisCombo, setMateriaisCombo] = useState([]);
  const [fabricantesAcordosCombo, setFabricantesAcordosCombo] = useState([]);

  const [clienteInput, setClienteInput] = useState("");
  const [fabricanteInput, setFabricanteInput] = useState("");

  const [alternativaInput, setAlternativaInput] = useState("");
  const [openDialogAlternativos, setOpenDialogAlternativos] = useState(false);
  const [openDialogFormAlternativo, setOpenDialogFormAlternativo] = useState(false);
  const [acordoAlternativosSelecionado, setAcordoAlternativosSelecionado] = useState(null);
  const [alternativosAcordo, setAlternativosAcordo] = useState([]);

  const [openConfirmInativarAcordo, setOpenConfirmInativarAcordo] = useState(false);
  const [acordoInativar, setAcordoInativar] = useState(null);

  const [formAlternativo, setFormAlternativo] = useState({
    id: null,
    idclienteacordomaterial: null,
    refmaterial: "",
    inativo: 0,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(false);

  const [openDialogValorReceber, setOpenDialogValorReceber] = useState(false);
  const [valorReceberData, setValorReceberData] = useState([]);
  const [loadingExcelValorReceber, setLoadingExcelValorReceber] = useState(false);
  const [valorFabricanteInput, setValorFabricanteInput] = useState("");
  const [valorReceberForm, setValorReceberForm] = useState({
    reffabricante: "",
    datainicial: "",
    datafinal: "",
  });

  const [form, setForm] = useState({
    id: null,
    refcliente: "",
    reffabricante: "",
    tipodesconto: "PERCENTAGEM",
    valor: "",
    suporte_jf_perc: 100,
    suporte_fabricante_perc: 0,
    datainicial: "",
    datafinal: "",
    utilizacao_unica: 0,
    obs: "",
    inativo: 0,
  });

  const initialKeep =
    (() => {
      try {
        const v = localStorage.getItem(KEEP_KEY);
        return v === null ? true : JSON.parse(v);
      } catch {
        return true;
      }
    })() ?? true;

  const [keepFilters, setKeepFilters] = useState(initialKeep);

  const initialFilters = keepFilters
    ? (() => {
        try {
          return JSON.parse(localStorage.getItem(FILTERS_KEY) || "[]");
        } catch {
          return [];
        }
      })()
    : [];

  const carregar = async () => {
    setLoading(true);
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClientesAcordosMateriais", {})
    );
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setData(Array.isArray(payload) ? payload : []);
  };

  const carregarClientesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelClientesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setClientesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesAcordosCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelFabricantesAcordosMateriaisCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesAcordosCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelMateriaisCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisCombo(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    carregar();
    carregarClientesCombo();
    carregarFabricantesCombo();
    carregarMateriaisCombo();
  }, []);

  const limparForm = () => {
    setForm({
      id: null,
      refcliente: "",
      reffabricante: "",
      tipodesconto: "PERCENTAGEM",
      valor: "",
      suporte_jf_perc: 100,
      suporte_fabricante_perc: 0,
      datainicial: "",
      datafinal: "",
      utilizacao_unica: 0,
      obs: "",
      inativo: 0,
    });

    setClienteInput("");
    setFabricanteInput("");
  };

  const abrirNovo = () => {
    setEditando(false);
    limparForm();
    setOpenDialog(true);
  };

  const abrirEditar = async (row) => {
    setEditando(true);

    setForm({
      id: row.id,
      refcliente: row.refcliente || "",
      reffabricante: row.reffabricante || "",
      tipodesconto: row.tipodesconto || "PERCENTAGEM",
      valor: row.valor ?? "",
      suporte_jf_perc: row.suporte_jf_perc ?? 100,
      suporte_fabricante_perc: row.suporte_fabricante_perc ?? 0,
      datainicial: row.datainicial ? String(row.datainicial).substring(0, 10) : "",
      datafinal: row.datafinal ? String(row.datafinal).substring(0, 10) : "",
      utilizacao_unica: Number(row.utilizacao_unica || 0),
      obs: row.obs || "",
      inativo: Number(row.inativo || 0),
    });

    setClienteInput(row.cliente ? `${row.cliente} (${row.refcliente})` : "");
    setFabricanteInput(row.fabricante ? `${row.fabricante} (${row.reffabricante})` : "");

    setAcordoAlternativosSelecionado(row);
    await carregarAlternativosAcordo(row.id);
    limparFormAlternativo();

    setOpenDialog(true);
  };

  const guardar = async () => {
    if (!form.refcliente || !form.reffabricante) {
      showAlert("Preenche cliente e fabricante.", "warning");
      return;
    }

    if (Number(form.valor || 0) <= 0) {
      showAlert(
        form.tipodesconto === "PERCENTAGEM"
          ? "Indica a percentagem de desconto."
          : "Indica o valor em euros.",
        "warning"
      );
      return;
    }

    const totalSuporte =
      Number(form.suporte_jf_perc || 0) + Number(form.suporte_fabricante_perc || 0);

    if (Math.round(totalSuporte * 1000000) / 1000000 !== 100) {
      showAlert("A soma do suporte JF e fabricante tem de ser 100%.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      ...form,
      valor: Number(form.valor || 0),
      suporte_jf_perc: Number(form.suporte_jf_perc || 0),
      suporte_fabricante_perc: Number(form.suporte_fabricante_perc || 0),
      datainicial: form.datainicial || null,
      datafinal: form.datafinal || null,
      utilizacao_unica: Number(form.utilizacao_unica || 0),
      inativo: Number(form.inativo || 0),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = editando
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterial"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterial";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    console.log("payload", _);
    console.log("meta", meta);

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Desconto adicional gravado.", meta?.severity || "success");

    await carregar();

    if (!editando) {
      const novoId = meta?.data?.id;

      if (novoId) {
        const novoAcordo = {
          ...form,
          id: novoId,
        };

        setForm((p) => ({
          ...p,
          id: novoId,
        }));

        setEditando(true);
        setAcordoAlternativosSelecionado(novoAcordo);
        setAlternativosAcordo([]);

        setFormAlternativo({
          id: null,
          idclienteacordomaterial: novoId,
          refmaterial: "",
          inativo: 0,
        });

        setAlternativaInput("");
        setOpenDialogFormAlternativo(true);

        return;
      }
    }

    setOpenDialog(false);
  };

  const pedirInativarAcordo = (acordo) => {
    setAcordoInativar(acordo);
    setOpenConfirmInativarAcordo(true);
  };

  const confirmarInativarAcordo = async () => {
    const acordo = acordoInativar;

    if (!acordo?.id) return;

    const body = {
      id: acordo.id,
      refcliente: acordo.refcliente || "",
      reffabricante: acordo.reffabricante || "",
      tipodesconto: acordo.tipodesconto || "PERCENTAGEM",
      valor: Number(acordo.valor || 0),
      suporte_jf_perc: Number(acordo.suporte_jf_perc || 0),
      suporte_fabricante_perc: Number(acordo.suporte_fabricante_perc || 0),
      datainicial: acordo.datainicial ? String(acordo.datainicial).substring(0, 10) : null,
      datafinal: acordo.datafinal ? String(acordo.datafinal).substring(0, 10) : null,
      utilizacao_unica: Number(acordo.utilizacao_unica || 0),
      obs: acordo.obs || "",
      inativo: Number(acordo.inativo || 0) === 1 ? 0 : 1,
      atualizado_por: userData?.id || null,
    };

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("ClientesAcordosMateriais/UpdClienteAcordoMaterial", body)
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(
      meta?.message ||
        (Number(acordo.inativo || 0) === 1
          ? "Acordo reativado com sucesso."
          : "Acordo inativado com sucesso."),
      meta?.severity || "success"
    );

    setOpenConfirmInativarAcordo(false);
    setAcordoInativar(null);

    await carregar();
  };

  const abrirValorReceber = () => {
    setValorReceberData([]);
    setValorFabricanteInput("");
    setValorReceberForm({
      reffabricante: "",
      datainicial: "",
      datafinal: "",
    });
    carregarFabricantesAcordosCombo();
    setOpenDialogValorReceber(true);
  };

  const consultarValorReceber = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelValorReceberFabricante", valorReceberForm)
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setValorReceberData(Array.isArray(payload) ? payload : []);
  };

  const totalValorReceberFabricante = valorReceberData.reduce(
    (acc, row) => acc + Number(row.valor_receber_fabricante || 0),
    0
  );

  const formatarValor = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });

  const exportarValorReceberExcel = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    try {
      setLoadingExcelValorReceber(true);

      const res = await api({
        url: "ClientesAcordosMateriais/ExportarValorReceberFabricante",
        method: "post",
        data: valorReceberForm,
        responseType: "arraybuffer",
      });

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `AcordosPrecos_${new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/[-:T]/g, "")
        .replace(/^(\d{6})(\d{4})$/, "$1_$2")}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar Excel.", "error");
    } finally {
      setLoadingExcelValorReceber(false);
    }
  };

  const limparFormAlternativo = () => {
    setAlternativaInput("");

    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordoAlternativosSelecionado?.id || form.id || null,
      refmaterial: "",
      inativo: 0,
    });
  };

  const carregarAlternativosAcordo = async (idclienteacordomaterial) => {
    if (!idclienteacordomaterial) return;

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClienteAcordoMaterialRefs", {
        idclienteacordomaterial,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativosAcordo(Array.isArray(payload) ? payload : []);
  };

  const abrirAlternativos = async (acordo) => {
    setAcordoAlternativosSelecionado(acordo);
    setAlternativosAcordo([]);
    setOpenDialogAlternativos(true);

    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordo.id,
      refmaterial: "",
      inativo: 0,
    });

    setAlternativaInput("");

    await carregarAlternativosAcordo(acordo.id);
  };

  const abrirEditarPrincipal = (acordo) => {
    setOpenDialogAlternativos(false);
    abrirEditar(acordo);
  };

  const abrirNovoAlternativo = () => {
    limparFormAlternativo();

    setFormAlternativo((p) => ({
      ...p,
      idclienteacordomaterial: acordoAlternativosSelecionado?.id || null,
    }));

    setOpenDialogFormAlternativo(true);
  };

  const editarAlternativo = (alt) => {
    setFormAlternativo({
      id: alt.id,
      idclienteacordomaterial: alt.idclienteacordomaterial,
      refmaterial: alt.refmaterial || "",
      inativo: Number(alt.inativo || 0),
    });

    setAlternativaInput(
      alt.material ? `${alt.material} (${alt.refmaterial})` : alt.refmaterial || ""
    );

    setOpenDialogFormAlternativo(true);
  };

  const guardarAlternativo = async () => {
    if (!formAlternativo.idclienteacordomaterial) {
      showAlert("Acordo principal inválido.", "error");
      return;
    }

    let refMaterialSelecionado = formAlternativo.refmaterial;

    if (!refMaterialSelecionado && alternativaInput) {
      const match = alternativaInput.match(/\(([^)]+)\)\s*$/);
      refMaterialSelecionado = match?.[1] || "";
    }

    if (!refMaterialSelecionado) {
      showAlert("Indica o material.", "warning");
      return;
    }

    const body = {
      id: formAlternativo.id,
      idclienteacordomaterial: formAlternativo.idclienteacordomaterial,
      refmaterial: refMaterialSelecionado,
      inativo: Number(formAlternativo.inativo || 0),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = formAlternativo.id
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterialRef"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterialRef";

    setLoading(true);
    const [_, err, meta] = await handleApi(api.post(endpoint, body));
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material gravado.", meta?.severity || "success");

    await carregarAlternativosAcordo(formAlternativo.idclienteacordomaterial);
    await carregar();

    setOpenDialogFormAlternativo(false);
    limparFormAlternativo();
  };

  const inativarAlternativo = async (alt) => {
    if (!alt?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("ClientesAcordosMateriais/InativarClienteAcordoMaterialRef", {
        id: alt.id,
        atualizado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Material inativado.", meta?.severity || "success");

    await carregarAlternativosAcordo(alt.idclienteacordomaterial);
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "acoes",
        disableFilters: true,
        width: 72,
        minWidth: 56,
        maxWidth: 90,
        Cell: ({ row }) => {
          const a = row.original;

          return (
            <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
              <IconButton
                size="small"
                color="primary"
                disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "u")}
                onClick={() => abrirEditar(a)}
                title="Editar desconto"
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="info"
                disabled={
                  !temPermissao("Menu Acordos Cliente/Fabricante", "u") ||
                  Number(a.totalmateriais || 0) === 0
                }
                onClick={() => abrirAlternativos(a)}
                title={Number(a.totalmateriais || 0) === 0 ? "Sem materiais" : "Resumo do acordo"}
              >
                <InfoIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color={Number(a.inativo || 0) === 1 ? "inherit" : "error"}
                disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "d")}
                onClick={() => pedirInativarAcordo(a)}
                title={Number(a.inativo || 0) === 1 ? "Reativar acordo" : "Inativar acordo"}
              >
                <BlockIcon fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
      { Header: "Cliente", accessor: "cliente", Filter: TextFilter },
      { Header: "Ref. Cliente", accessor: "refcliente", Filter: TextFilter },
      { Header: "Fabricante", accessor: "fabricante", Filter: TextFilter },

      { Header: "Tipo", accessor: "tipodesconto", Filter: TextFilter },
      {
        Header: "Valor",
        accessor: "valor",
        disableFilters: true,
        Cell: ({ row }) =>
          row.original.tipodesconto === "PERCENTAGEM"
            ? `${Number(row.original.valor || 0).toFixed(3)}%`
            : `${Number(row.original.valor || 0).toFixed(3)}€`,
      },
      {
        Header: "Suporte JF",
        accessor: "suporte_jf_perc",
        Filter: TextFilter,
        Cell: ({ value }) => `${Number(value || 0).toFixed(2)}%`,
      },
      {
        Header: "Suporte Fabr.",
        accessor: "suporte_fabricante_perc",
        Filter: TextFilter,
        Cell: ({ value }) => `${Number(value || 0).toFixed(2)}%`,
      },
      {
        Header: "Data inicial",
        accessor: "datainicial",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Data final",
        accessor: "datafinal",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Única",
        accessor: "utilizacao_unica",
        width: 90,
        minWidth: 90,
        Filter: SimNaoFilter,
        Cell: ({ value }) =>
          Number(value || 0) === 1 ? (
            <CheckCircleIcon style={{ color: "black" }} fontSize="small" />
          ) : (
            ""
          ),
      },
      { Header: "Fatura consumida", accessor: "fatura_consumida", Filter: TextFilter },
      {
        Header: "Ativo",
        accessor: "inativo",
        width: 90,
        minWidth: 90,
        Filter: AtivoFilter,
        Cell: ({ value }) =>
          Number(value || 0) === 0 ? (
            <CheckCircleIcon style={{ color: "black" }} fontSize="small" />
          ) : (
            <BlockIcon style={{ color: "black" }} fontSize="small" />
          ),
      },
      { Header: "Refs. Materiais", accessor: "refs_materiais", Filter: TextFilter },
      { Header: "Materiais", accessor: "materiais", Filter: TextFilter },
    ],
    [temPermissao]
  );

  const table = useTable(
    {
      columns,
      data,
      initialState: { filters: initialFilters },
      autoResetFilters: false,
      autoResetSortBy: false,
    },
    useFilters,
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setAllFilters, state } =
    table;

  useEffect(() => {
    try {
      localStorage.setItem(KEEP_KEY, JSON.stringify(keepFilters));
    } catch {}

    if (!keepFilters) {
      setAllFilters([]);
      try {
        localStorage.removeItem(FILTERS_KEY);
      } catch {}
    }
  }, [keepFilters, setAllFilters]);

  useEffect(() => {
    if (!keepFilters) return;

    try {
      localStorage.setItem(FILTERS_KEY, JSON.stringify(state.filters || []));
    } catch {}
  }, [state.filters, keepFilters]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox pt={1}>
        <Card>
          <MDBox p={{ xs: 1.5, md: 3 }}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems={{ xs: "stretch", md: "center" }}
              flexDirection={{ xs: "column", md: "row" }}
              gap={1}
              mb={2}
              sx={{
                "& .MuiButton-root": {
                  width: { xs: "100%", md: "auto" },
                },
              }}
            >
              <MDTypography variant="h6">Descontos adicionais cliente/material</MDTypography>

              <MDBox
                display="flex"
                alignItems={{ xs: "stretch", sm: "center" }}
                flexDirection={{ xs: "column", sm: "row" }}
                gap={1}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={keepFilters}
                      onChange={(e) => setKeepFilters(e.target.checked)}
                      size="small"
                    />
                  }
                  label="Manter filtros"
                />

                <MDButton
                  color="info"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "r")}
                  onClick={abrirValorReceber}
                >
                  Valor a receber
                </MDButton>

                <MDButton
                  color="success"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "w")}
                  onClick={abrirNovo}
                >
                  Novo desconto
                </MDButton>
              </MDBox>
            </MDBox>

            <MDBox sx={{ height: "68vh", overflow: "auto", borderRadius: 1, maxWidth: "100%" }}>
              <table
                {...getTableProps()}
                style={{ width: "100%", minWidth: 1450, borderCollapse: "collapse" }}
              >
                <thead>
                  {headerGroups.map((hg) => (
                    <tr {...hg.getHeaderGroupProps()}>
                      {hg.headers.map((col) => (
                        <th
                          {...col.getHeaderProps(col.getSortByToggleProps())}
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            background: "#fff",
                            textAlign: "left",
                            padding: "6px 8px",
                            fontSize: 12,
                            color: "#7b809a",
                            verticalAlign: "bottom",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                            width: col.width || (col.id === "acoes" ? 72 : undefined),
                            minWidth: col.minWidth || undefined,
                            maxWidth: col.maxWidth || undefined,
                          }}
                        >
                          <div>
                            {col.render("Header")}
                            {col.isSorted ? (col.isSortedDesc ? " ▼" : " ▲") : null}
                          </div>

                          {!col.disableFilters && (
                            <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 4 }}>
                              {col.canFilter ? col.render("Filter") : null}
                            </div>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);

                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            style={{
                              padding: "8px 10px",
                              borderTop: "1px solid #eee",
                              fontSize: 12,
                              color: "#1a2b4c",
                              width:
                                cell.column.width || (cell.column.id === "acoes" ? 72 : undefined),
                              minWidth: cell.column.minWidth || undefined,
                              maxWidth: cell.column.maxWidth || undefined,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      <Dialog
        open={openDialogValorReceber}
        onClose={() => setOpenDialogValorReceber(false)}
        maxWidth="xl"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Valor a receber do fabricante
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={1.5} mt={1}>
            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "2fr 1fr 1fr" }} gap={1.5}>
              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>

                <Autocomplete
                  size="small"
                  options={fabricantesAcordosCombo}
                  filterOptions={(x) => x}
                  inputValue={valorFabricanteInput}
                  getOptionLabel={fabricanteLabel}
                  value={
                    fabricantesAcordosCombo.find((f) => f.ref === valorReceberForm.reffabricante) ||
                    null
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      setValorFabricanteInput(value);
                      setValorReceberForm((p) => ({ ...p, reffabricante: "" }));
                      carregarFabricantesAcordosCombo(value);
                    }

                    if (reason === "clear") {
                      setValorFabricanteInput("");
                      setValorReceberForm((p) => ({ ...p, reffabricante: "" }));
                    }
                  }}
                  onChange={(_, value) => {
                    setValorReceberForm((p) => ({ ...p, reffabricante: value?.ref || "" }));
                    setValorFabricanteInput(value ? fabricanteLabel(value) : "");
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Data inicial</div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datainicial}
                  onChange={(e) =>
                    setValorReceberForm((p) => ({
                      ...p,
                      datainicial: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Data final</div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datafinal}
                  onChange={(e) =>
                    setValorReceberForm((p) => ({
                      ...p,
                      datafinal: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>
            </MDBox>

            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={1}
              flexWrap="wrap"
            >
              <MDBox
                display="flex"
                // justifyContent="space-between"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <MDButton color="info" onClick={consultarValorReceber}>
                  Consultar
                </MDButton>

                <MDButton
                  startIcon={
                    loadingExcelValorReceber ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <TableViewIcon />
                    )
                  }
                  color="success"
                  onClick={exportarValorReceberExcel}
                  disabled={loadingExcelValorReceber}
                >
                  {loadingExcelValorReceber ? "A gerar Excel..." : "Exportar Excel"}
                </MDButton>
              </MDBox>

              <MDTypography variant="h6">
                Total a receber: {formatarValor(totalValorReceberFabricante)} €
              </MDTypography>
            </MDBox>

            <MDBox sx={{ maxHeight: "50vh", overflow: "auto", borderRadius: 1, maxWidth: "100%" }}>
              <table style={{ width: "100%", minWidth: 2100, borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {[
                      "Cliente",
                      "Ref. Cliente",
                      "Material",
                      "Ref. Material",
                      "Data",
                      "Fatura",
                      "Estornada",
                      "Fatura Estornada",
                      // "Cat.",
                      "Qtd",
                      "Preço Acons.",
                      "Tipo",
                      "Valor",
                      "Suporte JF",
                      "Suporte Fabr.",
                      "Valor Receber",
                    ].map((h) => (
                      <th
                        key={h}
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          background: "#fff",
                          textAlign: "left",
                          padding: "6px 8px",
                          fontSize: 12,
                          color: "#7b809a",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {valorReceberData.map((row, idx) => (
                    <tr key={`${row.idacordo}-${row.faturanumero}-${idx}`}>
                      {[
                        row.cliente,
                        row.refcliente,
                        row.material,
                        row.refmaterial,
                        row.faturadata ? String(row.faturadata).substring(0, 10) : "",
                        row.faturanumero,
                        row.estornada,
                        row.faturaestornada,
                        // row.catitemnome,
                        `${row.qtd} ${row.qtdunid || ""}`,
                        formatarValor(row.precoaconselhado),
                        row.tipodesconto,

                        row.tipodesconto === "PERCENTAGEM"
                          ? `${formatarValor(row.valor)}%`
                          : `${formatarValor(row.valor)} €`,

                        `${formatarValor(row.suporte_jf_perc)}%`,
                        `${formatarValor(row.suporte_fabricante_perc)}%`,
                        `${formatarValor(row.valor_receber_fabricante)} €`,
                      ].map((value, i) => (
                        <td
                          key={i}
                          style={{
                            padding: "8px 10px",
                            borderTop: "1px solid #eee",
                            fontSize: 12,
                            whiteSpace: "nowrap",
                            fontWeight: i === 14 ? 700 : undefined,
                          }}
                        >
                          {value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
          <MDButton color="secondary" onClick={() => setOpenDialogValorReceber(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmInativarAcordo}
        onClose={() => {
          setOpenConfirmInativarAcordo(false);
          setAcordoInativar(null);
        }}
        maxWidth="xs"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {Number(acordoInativar?.inativo || 0) === 1
            ? "Confirmar reativação"
            : "Confirmar inativação"}
        </DialogTitle>

        <DialogContent>
          <MDTypography variant="body2">
            {Number(acordoInativar?.inativo || 0) === 1
              ? "Pretende reativar o acordo:"
              : "Pretende inativar o acordo:"}
          </MDTypography>

          <MDBox mt={1}>
            <MDTypography variant="body2" fontWeight="medium">
              {acordoInativar?.cliente}
            </MDTypography>

            <MDTypography variant="caption" color="text">
              {acordoInativar?.materiais}
            </MDTypography>
          </MDBox>
        </DialogContent>

        <DialogActions>
          <MDButton
            color="secondary"
            onClick={() => {
              setOpenConfirmInativarAcordo(false);
              setAcordoInativar(null);
            }}
          >
            Cancelar
          </MDButton>

          <MDButton
            color={Number(acordoInativar?.inativo || 0) === 1 ? "dark" : "error"}
            onClick={confirmarInativarAcordo}
          >
            {Number(acordoInativar?.inativo || 0) === 1 ? "Reativar" : "Inativar"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <DialogClienteAcordoMaterial
        open={openDialog}
        onClose={() => {
          if (form.id && alternativosAcordo.length === 0) {
            showAlert("Adicione pelo menos um material ao acordo.", "warning");
            return;
          }

          setOpenDialog(false);
        }}
        PaperComponent={PaperComponent}
        editando={editando}
        form={form}
        setForm={setForm}
        clientesCombo={clientesCombo}
        fabricantesCombo={fabricantesCombo}
        clienteInput={clienteInput}
        setClienteInput={setClienteInput}
        fabricanteInput={fabricanteInput}
        setFabricanteInput={setFabricanteInput}
        clienteLabel={clienteLabel}
        fabricanteLabel={fabricanteLabel}
        carregarClientesCombo={carregarClientesCombo}
        carregarFabricantesCombo={carregarFabricantesCombo}
        guardar={guardar}
        abrirMateriais={() => {
          if (!form.id) {
            showAlert("Grave primeiro o acordo.", "warning");
            return;
          }

          setAcordoAlternativosSelecionado(form);
          carregarAlternativosAcordo(form.id);
          setOpenDialogAlternativos(true);
        }}
      />

      <DialogClienteAcordoMaterialAlternativo
        open={openDialogFormAlternativo}
        onClose={() => {
          if (form.id && alternativosAcordo.length === 0) {
            showAlert("Adicione pelo menos um material ao acordo.", "warning");
            return;
          }

          setOpenDialogFormAlternativo(false);
        }}
        PaperComponent={PaperComponent}
        formAlternativo={formAlternativo}
        setFormAlternativo={setFormAlternativo}
        alternativaInput={alternativaInput}
        setAlternativaInput={setAlternativaInput}
        materiaisCombo={materiaisCombo}
        materiaisJaAssociados={alternativosAcordo}
        materialLabel={materialLabel}
        carregarMateriaisCombo={carregarMateriaisCombo}
        guardarAlternativo={guardarAlternativo}
      />

      <DialogClienteAcordoMaterialAlternativosLista
        open={openDialogAlternativos}
        onClose={() => setOpenDialogAlternativos(false)}
        PaperComponent={PaperComponent}
        acordo={acordoAlternativosSelecionado}
        alternativos={alternativosAcordo}
        formatarValor={formatarValor}
        modoEdicao={openDialog}
        abrirNovoAlternativo={abrirNovoAlternativo}
        editarAlternativo={editarAlternativo}
        inativarAlternativo={inativarAlternativo}
      />
    </DashboardLayout>
  );
}
